import { useState, useEffect } from 'react';
import { Moon, Sun, Bell } from 'lucide-react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import useThemeStore from '@/store/useThemeStore';
import useAuthStore from '@/store/useAuthStore';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';

export default function Topbar() {
  const { theme, toggleTheme } = useThemeStore();
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [whatsappConnected, setWhatsappConnected] = useState(false);

  useEffect(() => {
    const fetchBusinessStatus = async () => {
  try {
    // ✅ Twilio aur Meta dono check karo
    const [twilioRes, metaRes] = await Promise.all([
      api.get('/whatsapp/connection-status'),
      api.get('/whatsapp/meta-connection-status'),
    ])

    const twilioConnected = twilioRes.data?.connected || false
    const metaConnected   = metaRes.data?.connected   || false

    setWhatsappConnected(twilioConnected || metaConnected)
  } catch (error) {
    console.error('Failed to fetch business status:', error)
  }
}



    //const fetchBusinessStatus = async () => {
      //try {
      //  const response = await api.get('/business');
       /// setWhatsappConnected(response.data.whatsapp_connected);
     // } catch (error) {
     //   console.error('Failed to fetch business status:', error);
     // }
  //  };

    fetchBusinessStatus();
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="border-b border-border bg-card px-6 py-4" data-testid="topbar">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <h1 className="text-xl font-outfit font-semibold text-foreground">
            {user?.business_name || 'My Business'}
          </h1>
          <div className="flex items-center gap-2">
            <div
              className={`w-2 h-2 rounded-full ${
                whatsappConnected ? 'bg-whatsapp' : 'bg-destructive'
              } animate-pulse`}
            />
            <span className="text-sm text-muted-foreground">
              {whatsappConnected ? 'WhatsApp Connected' : 'Not Connected'}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {/* Theme Toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            data-testid="theme-toggle"
            className="relative"
          >
            {theme === 'dark' ? (
              <Sun className="w-5 h-5" />
            ) : (
              <Moon className="w-5 h-5" />
            )}
          </Button>

          {/* Notifications */}
          <Button variant="ghost" size="icon" data-testid="notifications-button">
            <Bell className="w-5 h-5" />
          </Button>

          {/* User Menu */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="user-menu"
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              >
                <Avatar>
                  <AvatarFallback className="bg-whatsapp text-black font-semibold">
                    {user?.email?.[0]?.toUpperCase() || 'U'}
                  </AvatarFallback>
                </Avatar>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="flex flex-col">
                  <span className="font-medium">{user?.business_name}</span>
                  <span className="text-xs text-muted-foreground">{user?.email}</span>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => navigate('/settings')}>
                Settings
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleLogout} data-testid="logout-button">
                Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
